import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, BrandingSettingsDialogueHandler } from './types';
import UpdatePaylinkCpmtext from './BrandingSettingsContext';

const { ConfirmationDialogue } = vp;

type PaylinkDialogueProps = {
  handleDialogue: DialogueHandler<BrandingSettingsDialogueHandler>;
};

type FC = FunctionComponent<PaylinkDialogueProps>;

const BrandingSettingsDialogue: FC = ({ handleDialogue }: PaylinkDialogueProps) => {
  const { showSuccessAlert, showErrorAlert, error } = useContext(UpdatePaylinkCpmtext);
  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showErrorAlert}
          title="Error! Branding Settings not updated."
          status="error"
          buttonWidth="210px"
          subTitle={`${error}`}
          confirm={{
            label: 'Back to Brand Settings',
            action: () => handleDialogue({ type: 'error', state: 'success' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showSuccessAlert}
          title="Success! Branding Settings was updated"
          status="success"
          subTitle="Navigate back to brand settings."
          buttonWidth="210px"
          confirm={{
            label: 'Back to Brand Settings',
            action: () => handleDialogue({ type: 'save', state: 'success' }),
          }}
        />
      </div>
    ),
    [showSuccessAlert, showErrorAlert, error],
  );
};

export default BrandingSettingsDialogue;
